import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { reactLocalStorage } from 'reactjs-localstorage';
import LinearProgress from '@material-ui/core/LinearProgress';
import { CsvBuilder } from 'filefy';
import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import moment from "moment";
import ReloadIcon from '@material-ui/icons/Replay';


import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";

const styles = theme => ({
});


const defaults = {
    id: false,
    company: false,
    name: false,
    reference: false,
    zipCode: false,
    street: false,
    place: false,
    phone: false,
    contact: false,
    admin: false,
    receives_email: false,
    pageSize: 20,
};


const defaultsPropertyName = 'p71.tenants.defaults';

class Tenants extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    getInput = (data) => {

        try {

            const input = {}

            helper.set(input, data, "company");
            helper.set(input, data, "admin");
            helper.set(input, data, "contact");
            helper.set(input, data, "name");
            helper.set(input, data, "reference");
            helper.set(input, data, "street");
            helper.set(input, data, "zipCode");
            helper.set(input, data, "place");
            helper.set(input, data, "phone");
            helper.set(input, data, "receives_email");

            if (!input["admin"]) input["admin"] = null
            if (!input["contact"]) input["contact"] = null
            if (!input["name"]) input["name"] = null
            if (!input["reference"]) input["reference"] = null
            if (!input["street"]) input["street"] = null
            if (!input["zipCode"]) input["zipCode"] = null
            if (!input["place"]) input["place"] = null
            if (!input["phone"]) input["phone"] = null
            if (!input["receives_email"]) input["receives_email"] = false

            return input;

        } catch (error) {
            throw new Error(i18n.get("tenants.error.validation"))
        }
    }

    hasChildren = async (id) => {
        try {

            const result = await graphql.clientWithToken(this.props.accessToken).query({
                variables: {
                    "id": id,
                },
                query: gql`
                query tenant($id: ID!) { 
                    tenant (id: $id) {
                        buildings {
                            id
                        }
                }
            }
            `,
                fetchPolicy: "no-cache"
            });

            return result.data.tenant.buildings.length > 0;

        } catch (error) {
            console.log(error.message);
            return false
        }
    }

    exportCsv = async (columns, data) => {

        try {

            this.setState({
                exporting: true,
                progressValue: 0
            });

            const allTenants = [];
            let totalCount = 0;
            const first = 100;
            let offset = 0

            this.showMessage("Export wird angestoßen. Bitte verlassen Sie die Seite nicht, solange der Exportvorgang läuft.", "info");

            do {
                
                const filters = []
                for (const column of columns) {
                    if (column.tableData.filterValue !== undefined && column.tableData.filterValue !== null) {
                        filters.push({
                            column: column,
                            field: column.field,
                            type: column.type,
                            comparator: column.comparator,
                            value: column.tableData.filterValue
                        })
                    }
                }

                const find = helper.whereString(filters, this.mapField, ["id"]);

                const result = await graphql.clientWithToken(this.props.accessToken).query({
                    query: gql`
                    query {
                        tenants(first: 100, offset: ${offset}, where: ${find}, orderBy: [{column: "id" direction: ASC}]) {
                            totalCount
                            elements {
                                ... on Tenant {
                                    id
                                    company,
                                    name,
                                    reference,
                                    contact,
                                    admin
                                    street
                                    zipCode
                                    place
                                    phone
                                    receives_email
                                }
                            }
                        }
                    }
                `,
                    fetchPolicy: "no-cache"
                });

                totalCount = result.data.tenants.totalCount;
                offset = offset + first;
                for (const tenant of result.data.tenants.elements) {
                    allTenants.push(
                        {
                            company: tenant.company,
                            name: tenant.name,
                            reference: tenant.reference,
                            contact: tenant.contact,
                            admin: tenant.admin,
                            street: tenant.street,
                            zipCode: tenant.zipCode,
                            place: tenant.place,
                            phone: tenant.phone,
                            id: tenant.id,
                            receives_email: tenant.receives_email ? 'Ja' : 'Nein'
                        }
                    )
                }

                if (totalCount !== 0) {
                    this.setState({
                        exporting: true,
                        progressValue: (allTenants.length / totalCount) * 100
                    });
                }
            } while (allTenants.length < totalCount);

            const builder = new CsvBuilder('Kunden.csv')
                .setDelimeter(";")
                .setColumns(columns.map(columnDef => columnDef.title))
                .addRows(allTenants.map(tenant => { return [tenant.company, tenant.id, tenant.reference, tenant.name, tenant.street, tenant.zipCode, tenant.place, tenant.phone, tenant.contact, tenant.admin, tenant.receives_email] }))
                .exportFile();

            this.setState({
                exporting: false,
                progressValue: 0
            });
        } catch (error) {
            this.setState({
                exporting: false,
                progressValue: 0
            });
            this.showMessage(error.message, "error");
        }

    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    mapField(column) {
        return column;
    }

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>

                {this.state.exporting && <div style={{ width: "100%" }}><LinearProgress value={this.state.progressValue} variant={"determinate"} /></div>}

                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("tenants.company"),
                            field: 'company',
                            hidden: this.default("company"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            sorting: true,
                            filtering: true,
                            editable: "always",

                        },
                        {
                            title: i18n.get("tenants.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            defaultFilter: (this.props.pageData && this.props.pageData.id) || null,
                            sorting: true,
                            filtering: true,
                            editable: "never",
                        },
                        {
                            title: i18n.get("tenants.reference"),
                            field: 'reference',
                            hidden: this.default("reference"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            sorting: true,
                            filtering: true,
                            editable: "always",

                        },
                        {
                            title: i18n.get("tenants.name"),
                            field: 'name',
                            hidden: this.default("name"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            sorting: true,
                            filtering: true,
                            editable: "always",

                        },
                        {
                            title: i18n.get("tenants.street"),
                            field: 'street',
                            hidden: this.default("street"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            sorting: true,
                            filtering: true,
                            editable: "always",

                        },
                        {
                            title: i18n.get("tenants.zipCode"),
                            field: 'zipCode',
                            hidden: this.default("zipCode"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            sorting: true,
                            filtering: true,
                            editable: "always",

                        },
                        {
                            title: i18n.get("tenants.place"),
                            field: 'place',
                            hidden: this.default("place"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            sorting: true,
                            filtering: true,
                            editable: "always",

                        },
                        {
                            title: i18n.get("tenants.phone"),
                            field: 'phone',
                            hidden: this.default("phone"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            sorting: true,
                            filtering: true,
                            editable: "always",

                        },
                        {
                            title: i18n.get("tenants.contact"),
                            field: 'contact',
                            hidden: this.default("contact"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            sorting: false,
                            filtering: true,
                            editable: "always",
                            tooltip: i18n.get("tenants.contact.tooltip")

                        },
                        {
                            title: i18n.get("tenants.admin"),
                            field: 'admin',
                            hidden: this.default("admin"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            sorting: false,
                            filtering: true,
                            editable: "always",
                            tooltip: i18n.get("tenants.admin.tooltip")

                        },
                        {
                            title: i18n.get("tenants.receives_email"),
                            field: 'receives_email',
                            hidden: this.default("receives_email"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            sorting: true,
                            filtering: true,
                            type: "boolean",
                            editable: "always",

                        },
                    ]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {

                                const where = helper.whereString(query['filters'], this.mapField, ["id"]);
                                let orderBy = helper.orderByString(query, this.mapField, 'id', true);
                                if (where === "[]") {
                                    orderBy = helper.orderByString(query, this.mapField, "id")
                                }

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        tenants(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on Tenant {
                                                    id
                                                    company,
                                                    name,
                                                    reference,
                                                    contact,
                                                    admin
                                                    street
                                                    zipCode
                                                    place
                                                    phone
                                                    receives_email
                                                    leases {
                                                        device {
                                                        uuid
                                                        imei
                                                        }
                                                    }
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.tenants.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                company: element.company,
                                                name: element.name,
                                                reference: element.reference,
                                                street: element.street,
                                                zipCode: element.zipCode,
                                                place: element.place,
                                                phone: element.phone,
                                                contact: element.contact,
                                                admin: element.admin,
                                                leases: element.leases,
                                                receives_email: element.receives_email
                                            };
                                        }),
                                    totalCount: result.data.tenants.totalCount
                                }
                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                    detailPanel={
                        rowData => {
                            return (
                                <div>
                                    <Paper>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">{i18n.get("tenants.device.uuid")}</TableCell>
                                                    <TableCell align="center">{i18n.get("tenants.device.imei")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rowData.leases.map(row => (
                                                    <TableRow key={row.device.uuid}>
                                                        <TableCell align="center" component="th" scope="row"> {row.device.uuid} </TableCell>
                                                        <TableCell align="center">{row.device.imei}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                </div>
                            );
                        }
                    }
                    actions={[{
                        isFreeAction: true,
                        icon: () => { return <ReloadIcon /> },
                        tooltip: i18n.get("general.reload"),
                        onClick: async (event, rowData) => {
                            this.tableRef.current.onQueryChange();
                        }
                    }]}
                    title={i18n.get("tenants.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: !this.state.exporting,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        exportCsv: this.exportCsv,
                        pageSize: this.default("pageSize"),
                        pageSizeOptions: [5, 20, 50]
                    }}
                    
                    editable={{
                        isEditable: rowData => isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]),
                        isDeletable: rowData => isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]),
                        onRowAdd: isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]) ? newData =>
                            new Promise(async (resolve, reject) => {
                                try {

                                    const input = this.getInput(newData)

                                    const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                        variables: {
                                            "id": newData.id,
                                            "input": input,
                                        },
                                        mutation: gql`
                                        mutation addTenant($input: TenantInput!) {
                                            addTenant(input: $input) {
                                                id
                                            }
                                        }
                                    `,
                                    });

                                    this.showMessage(i18n.get("tenants.message.onRowAdd.success"), "success")
                                    this.tableRef.current.onQueryChange();

                                    resolve();
                                } catch (error) {
                                    this.showMessage(i18n.get("tenants.message.onRowAdd.error"), "error", error.message);
                                    reject(error);
                                }
                            }) : null,
                        onRowUpdate: (newData, oldData) =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    const input = this.getInput(newData);

                                    const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                        variables: {
                                            "id": newData.id,
                                            "input": input,
                                        },
                                        mutation: gql`
                                        mutation updateTenant($id: ID!, $input: TenantInput!) {
                                            updateTenant(id: $id, input: $input) {
                                                id
                                            }
                                        }
                                    `,
                                    });


                                    this.showMessage(i18n.get("tenants.message.onRowUpdate.success"), "success")

                                    resolve(result);
                                } catch (error) {

                                    this.showMessage(i18n.get("tenants.message.onRowUpdate.error"), "error", error.message)
                                    reject(error);
                                }
                            }),
                        onRowDelete: oldData =>
                            new Promise(async (resolve, reject) => {

                                try {
                                    const hasChildren = await this.hasChildren(oldData.id)

                                    if (!hasChildren) {

                                        const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                            variables: {
                                                "id": oldData.id,
                                            },
                                            mutation: gql`
                                            mutation deleteTenant($id: ID!) {
                                                deleteTenant(id: $id)
                                            }
                                        `,
                                        });

                                        this.showMessage(i18n.get("tenants.message.onRowDelete.success"), "success")

                                        resolve(result);

                                    } else {
                                        this.showMessage(i18n.get("tenants.message.onRowDelete.notEmpty"), "error")
                                        reject();
                                    }

                                } catch (error) {
                                    this.showMessage(i18n.get("tenants.message.onRowDelete.error"), "error", error.message)
                                    reject(error);
                                }
                            }),
                    }}

                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </div>
        )
    }
}

Tenants.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Tenants))